<template>
  <div>
    <div class="header_container">
      <!--左边区域-->
      <div class="left_box">
        <!--logo图片-->
        <div class="logo_box" v-if="!isCollapsed">
          <img :src="logoUrl" width="210" height="22" :alt="altTitle"/>
        </div>
        <!--展开与收起侧边栏按钮-->
        <Icon type="md-menu" size="26" @click.native="toggleClick" v-if="showNav" class="toggleMenu"></Icon>
        <span class="logo_box_title">{{ altTitle }}</span>
      </div>
      <!--订单超时未发提示-->
      <div class="timeout_box" v-if="system === 'supplier' && overTimeNum>0">
        <Icon type="md-warning" size="21" color="#D9001B" class="mr5"/>
        <div class="flex align-items-center pt2">
          <span>{{ $t('key1000019') + overTimeNum + $t('key1000020') }}</span>
          <span class="cursor" style="text-decoration: underline;" @click="handleTimedSentData('all')">
          {{ $t('key1000021') }}
        </span>
        </div>
      </div>
      <!--右边区域-->
      <div class="right_box">
        <!--右边用户信息-->
        <div class="user_info_box">
          <!--消息提醒-->
          <Poptip trigger="hover" :transfer="false" class="message_reminder_box" width="320" padding="0" v-if="messageReminderList.length >0">
            <Badge :count="unReadCount" :offset="[12,-8]">
              <Icon type="ios-notifications-outline" color="#fff" size="24" class="cursor" @click="lookMoreBtn"></Icon>
            </Badge>
            <template #content>
              <div v-show="poptipTalg">
                <ul class="message_reminder_list">
                  <li class="message_reminder_item" v-for="(item, index) in messageReminderList" :key="index" @click="viewMessageBtn(item)">
                    <Icon type="md-mail" size="20" color="#fff" class="message_icon"/>
                    <div class="message_line">
                      <h3 class="title">{{ item.title }}</h3>
                      <p class="time">{{ item.timer }}</p>
                    </div>
                  </li>
                  <li class="message_reminder_item more_style" v-if="messageReminderList.length >=5" @click="lookMoreBtn">{{ $t('key1000022') }}</li>
                </ul>
              </div>
            </template>
          </Poptip>
          <Icon type="ios-notifications-outline" color="#fff" size="24" v-else class="mr15 font-weight-bold cursor" @click="lookMoreBtn"></Icon>
          <!--语种-->
          <Dropdown transfer @on-click="changeLanguage" class="mr15 languages">
            <img :src="flagPath" width="30" height="20" class="cursor" alt="">
            <template #list>
              <Dropdown-menu>
                <Dropdown-item v-for="(item, index) in languageList" :name="item.name" :key="index">
                  <img :src="item.iconPath" width="30" height="20" class="cursor mr10" alt="">
                  <span class="font-size-12">{{ item.title }}</span>
                  <Icon class="ml8" type="md-checkmark" size="18" color="#FD5425" v-if="flagPath == item.iconPath"/>
                </Dropdown-item>
              </Dropdown-menu>
            </template>
          </Dropdown>
          <!--时区-->
          <Poptip placement="bottom" class="time_zone mr15">
            <div class="text">UTC{{ UTCtimezoom }}</div>
            <template #content>
              <div>
                <div class="timer_box">
                  <span>{{ $t('key1000023') }}</span> <Select v-model="timeModal" filterable style="width:250px;" @on-change="changeTimezoom">
                  <Option v-for="(item,index) in timezoomList" :value="item.utcId" :key="index">{{ item.text }}</Option>
                </Select>
                </div>
                <div class="timevalue">{{ $t('key1000024') }}{{ nowTime }}</div>
                <div class="timevalue">{{ $t('key1000025') }}{{ UTCtime }}</div>
              </div>
            </template>
          </Poptip>
          <!--登出-->
          <Dropdown transfer @on-click="logout" class="mr15">
            <div class="icon_box">
              <span class="iconfont icon-yonghu">&#xe713;</span> <span class="text_name">{{ userInfo.userName }}</span>
            </div>
            <template #list>
              <Dropdown-menu>
                <!--登出-->
                <Dropdown-item name="signOut">
                  <div class="logout_item">
                    <Icon type="md-log-out" class="icon_logout"></Icon>
                    <span class="text">{{ $t('key1000026') }}</span>
                  </div>
                </Dropdown-item>
              </Dropdown-menu>
            </template>
          </Dropdown>
          <!--通途客户编号-->
          <span class="user_info mr15">{{ merchantText + userInfo.merchantId }}</span>
          <span class="user_info mr15 cursor" @click="toHelpPage">{{ $t('key1000027') }}</span>
          <!--基础功能设置的入口-->
          <Icon
            v-if="system === 'yms'"
            type="md-settings"
            size="19"
            color="#fff"
            @click="switchBtn"
            style="position: relative; top: -2px; cursor: pointer;"/>
        </div>
      </div>
    </div>
    <!--侧边栏设置区域-->
    <functionSettings ref="settings" @updateData="updateData"></functionSettings>
    <!--超时订单处理弹窗-->
    <overtimeOrderProcessingModal ref="overtimeOrderProcess"></overtimeOrderProcessingModal>
    <!--系统公告弹窗-->
    <viewAnnouncementModal :isRegisterTimeAfter="1" ref="viewAnnouncement"></viewAnnouncementModal>
  </div>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import * as timezoom from '@/utils/timezooms';
import {getToken, removeToken} from '@/utils/cookie';
import api from '@/api/';
import functionSettings from "@/components/common/functionSettings";
import overtimeOrderProcessingModal from "@/components/common/overtimeOrderProcessingModal";
import {verifyLoginTicket, errorUrlHandel, deleteTicket, commonSessionStorage, handleLogoUrl, changeUserLanguages} from "@/utils/common";
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import {getSystemLanguage} from "@/utils/user";
import {startLoading} from "@/utils/loading";

export default {
  mixins: [Mixin],
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    showNav: { // 默认开启自定义的导航的模块
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flagPath: commonSessionStorage.getItem('selectLang') || '',
      timeModal: '',
      timezoomList: timezoom.timeList,
      nowTime: '',
      UTCtime: '',
      poptipTalg: true,
      overTimeNum: localStorage.getItem('overTimeNum') || 0,
      isPageVisible: true,
      timedTasksTimer: null,
      localTimeTimer: null,
      utcTimeTimer: null,
      webSocketListenerKey: '',
      resizeObserver: null,
      scrollbarTimer: null,
      _cachedScrollbarWidth: undefined,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 获取时区
    UTCtimezoom() {
      let timeZone = this.$store.state.erpConfig.timeZone;
      if (timeZone && this.timezoomList) {
        let timezoom = '';
        this.timezoomList.forEach(i => {
          if (i.utcId === timeZone) {
            timezoom = i.offset;
          }
        });
        timezoom = timezoom >= 0 ? '+' + timezoom : timezoom;
        if (localStorage.getItem('timezoom') !== timezoom) {
          localStorage.setItem('timezoom', timezoom);
        }
        return timezoom;
      } else {
        return this.$uDate.getDefaultTimezoom();
      }
    },
    // logo 标识名称
    altTitle() {
      let text = '';
      let pathname = window.location.pathname;
      let systemList = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000013'), pathname: '/yms.html'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014'), pathname: '/supplier.html'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000015'), pathname: '/distributor.html'}
      ];
      systemList.map((item) => {
        if (pathname.includes(item.pathname)) {
          text = item.title;
        }
      });
      return text;
    },
    // 未读消息数量
    unReadCount() {
      return this.$store.state.unreadTotal;
    },
    // 未读消息数据
    messageReminderList() {
      return this.$store.state.unreadData;
    },
    merchantText() {
      return this.system === 'supplier' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000016') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000017');
    },
    // logo图
    logoUrl() {
      return handleLogoUrl();
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.$nextTick(() => {
      this.setScrollbarWidth();
      this.initResizeObserver();
    });
    // 监听窗口变化
    window.addEventListener('resize', this.setScrollbarWidth);
  },
  created() {
    let v = this;
    v.getTimedSentData();
    v.getLocalTime();
    v.getUTC();
    getSystemLanguage(v.userInfo).then(({langCode, configureLanguage}) => {
      v.languageList = configureLanguage;
      configureLanguage.map(item => {
        if (item.name === langCode) {
          v.flagPath = item.iconPath;
          v.selectLang = item.title;
        }
      });
    });
    v.initWebSocket();
  },
  methods: {
    /**
     * 获取浏览器真实滚动条宽度
     * 通过创建隐藏元素强制显示滚动条来测量
     * 同一浏览器的滚动条宽度不变，因此缓存首次计算结果
     */
    getRealScrollbarWidth() {
      if (this._cachedScrollbarWidth !== undefined) {
        return this._cachedScrollbarWidth;
      }
      const outer = document.createElement('div');
      outer.style.cssText = 'visibility:hidden;overflow:scroll;width:50px;height:50px;position:absolute;top:-9999px;';
      document.body.appendChild(outer);
      const inner = document.createElement('div');
      inner.style.height = '100px';
      outer.appendChild(inner);
      const scrollbarWidth = outer.offsetWidth - outer.clientWidth;
      document.body.removeChild(outer);
      this._cachedScrollbarWidth = scrollbarWidth;
      return scrollbarWidth;
    },
    /**
     * 设置滚动条宽度 CSS 变量
     * 通过判断 #app 内容是否超出，决定是否设置滚动条偏移
     */
    setScrollbarWidth() {
      clearTimeout(this.scrollbarTimer);
      this.scrollbarTimer = setTimeout(() => {
        const appElement = document.getElementById('app');
        if (!appElement) return;
        const hasScrollbar = appElement.scrollHeight > appElement.clientHeight;
        const scrollbarWidth = hasScrollbar ? this.getRealScrollbarWidth() : 0;
        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      }, 50);
    },
    /**
     * 初始化 ResizeObserver
     * 监听 #app 元素的尺寸变化，自动重新计算滚动条宽度
     * 适用于：页面异步加载内容、动态增删元素等场景
     */
    initResizeObserver() {
      const appElement = document.getElementById('app');
      if (!appElement) return;
      // 如果浏览器支持 ResizeObserver
      if (window.ResizeObserver) {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        // #app 尺寸变化时重新计算滚动条宽度
        this.resizeObserver = new ResizeObserver(() => {
          this.setScrollbarWidth();
        });
        // 开始观察 #app 元素
        this.resizeObserver.observe(appElement);
      } else {
        console.warn('ResizeObserver not supported, fallback to MutationObserver');
        this.initMutationObserver(appElement);
      }
    },

    /**
     * 降级方案：使用 MutationObserver 监听 DOM 变化
     */
    initMutationObserver(appElement) {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      this.resizeObserver = new MutationObserver(() => {
        this.setScrollbarWidth();
      });
      this.resizeObserver.observe(appElement, {
        childList: true,    // 监听子节点增删
        subtree: true,      // 监听所有后代节点
        attributes: true,   // 监听属性变化
        attributeFilter: ['style', 'class']
      });
    },
    /**
     * 更新当前页面可见状态，避免后台标签页继续跑高频轮询。
     */
    handleVisibilityChange() {
      this.isPageVisible = !document.hidden;
    },

    /**
     * 注册头部消息中心使用的 websocket 监听。
     * @returns {void}
     */
    initWebSocket() {
      const v = this;
      let pathname = window.location.pathname;
      let url = '';
      if (pathname.includes('/yms.html')) {
        url = api.get_ymsStationNotification_lastUnRead;
      } else if (pathname.includes('/supplier.html')) {
        url = api.get_ymsSupplierStationNotification_lastUnRead;
      }
      v.getMessageNotificationData(url);
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `layout-header-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const receiveData = v.$webSocket.parseMessage(e);
        if (receiveData && receiveData.type === 'notice') {
          v.getMessageNotificationData(url);
        }
      }, v);
    },

    /**
     * 清理当前头部组件注册的 websocket 监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 展开与收起侧边栏菜单
    toggleClick() {
      this.$emit('collapsedSider', !this.isCollapsed);
      this.$store.commit('showSidebarMenu', !this.isCollapsed);
    },
    // 退出登录
    logout(value) {
      if (value === 'signOut') {
        let v = this;
        v.$webSocket.destroyWebSocket(true);
        startLoading(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000018'));
        v.axios.get(api.get_logout + getToken(), null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000018')}).then(response => {
          if (response.data.code === 0) {
            removeToken().then(() => {
              setTimeout(() => {
                let url = deleteTicket(window.location.href);
                url = errorUrlHandel(url);
                window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
              }, 1500);
            });
          }
        });
      }
    },
    // 切换语种
    changeLanguage(lang) {
      let v = this;
      changeUserLanguages(lang).then((value) => {
        if (value) {
          v.languageList.map((item) => {
            if (item.name === lang) {
              v.flagPath = item.iconPath;
              commonSessionStorage.setItem('flagPath', item.iconPath);
              localStorage.setItem('setLanguages', item.name);
              localStorage.setItem('lang', item.name);
            }
          });
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      });
    },
    // 设置时区
    setTime() {
      let v = this;
      return new Promise(resolve => {
        v.axios.put(api.put_updateTimeZone, {
          timeZoneId: v.timeModal
        }, {loading: true}).then(res => {
          if (res.data.code === 0) {
            resolve();
          }
        });
      });
    },
    // 选取时区
    changeTimezoom() {
      let v = this;
      let timeData;
      if (v.timeModal >= 0) {
        timeData = '+' + v.timeModal;
      } else {
        timeData = v.timeModal;
      }
      localStorage.setItem('timezoom', timeData);
      v.$store.commit('timezoomChange', timeData);
      v.$uDate.getNowTime();
      v.setTime().then(() => {
        window.location.reload();
      });
    },
    /**
     * 启动本地时间时钟。
     */
    getLocalTime() {
      let v = this;
      clearInterval(v.localTimeTimer);
      v.localTimeTimer = setInterval(function () {
        v.nowTime = v.$uDate.getCurrentTime('fulltime');
      }, 1000);
    },

    /**
     * 启动 UTC 时间时钟。
     */
    getUTC() {
      let v = this;
      clearInterval(v.utcTimeTimer);
      v.utcTimeTimer = setInterval(function () {
        v.UTCtime = v.$uDate.getUniversalTime(new Date().getTime(), 'fulltime');
      }, 1000);
    },
    // 打开功能设置
    switchBtn() {
      this.$refs.settings.functionSettingsDrawer = true;
    },
    // 设置功能后，重新渲染页面
    updateData() {
      let key = new Date().getTime();
      this.$emit('updateMenu', key);
    },
    // 查看当前消息
    viewMessageBtn(item) {
      let v = this;
      let noticeInfoId = item.noticeInfoId || null;
      // 系统公告消息
      if (noticeInfoId) {
        v.$refs['viewAnnouncement'].markAsReadBtn(noticeInfoId).then(() => {
          v.$refs['viewAnnouncement'].getViewAnnouncementData(noticeInfoId);
        });
      }
      // 消息模板通知
      else {
        let pathname = window.location.pathname;
        let url = '';
        let apiUrl = '';
        if (pathname.includes('/yms.html')) {
          url = api.get_ymsStationNotification_lastUnRead;
          apiUrl = api.post_ymsStationNotification_batchRead;
        } else if (pathname.includes('/supplier.html')) {
          url = api.get_ymsSupplierStationNotification_lastUnRead;
          apiUrl = api.post_ymsSupplierStationNotification_batchRead;
        }
        v.axios.post(apiUrl, [item.ymsStationNotificationId], {loading: true}).then(response => {
          if (response.data.code === 0) {
            v.$router.push({
              path: '/messageMailboxes',
              query: {
                ymsReceiveStationNotificationLogId: item.ymsReceiveStationNotificationLogId
              }
            });
            v.getMessageNotificationData(url);
            v.poptipTalg = false;
            setTimeout(() => {
              v.poptipTalg = true;
            }, 500);
          }
        });
      }
    },
    // 查看更多消息
    lookMoreBtn() {
      let v = this;
      v.$router.push('/messageCenter');
      v.poptipTalg = false;
      setTimeout(() => {
        v.poptipTalg = true;
      }, 500);
    },
    // 获取超时未发的数据
    getTimedSentData() {
      // 首次登录的时候，如果有超时未发的数据且有供应商订单列表就弹窗出标记缺货的弹窗
      let v = this;
      if (v.system === 'supplier') {
        v.axios.post(api.post_ymsSupplierUserInfo_queryOperByMenu + 'supplier_supplierOrderList' + `?subsystemCode=yms-supplier-service`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0 && data.includes('packageInfo_queryPackageInfoOrder')) {
              v.handleTimedTasks('all');
              verifyLoginTicket().then((val) => {
                if (val) {
                  v.handleTimedSentData().then((data) => {
                    if (data.length > 0) {
                      v.overTimeNum = data.length;
                      v.$store.commit('overTimeNum', data.length);
                      v.$refs['overtimeOrderProcess'].initOvertimeOrderProcessingData('timeout', data, 1);
                    } else {
                      v.overTimeNum = 0;
                      v.$store.commit('overTimeNum', 0);
                    }
                  });
                }
              });
            } else {
              v.overTimeNum = 0;
            }
          }
        });
      }
    },
    // 处理超时未发的数据
    handleTimedSentData(type) {
      let v = this;
      return new Promise((resolve) => {
        let query = [];
        v.overTimeNum = 0;
        localStorage.setItem('overTimeNum', 0);
        v.axios.post(api.post_packageInfo_queryOvertimeUnsentList, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let newData = data.slice(0, 100);
              v.overTimeNum = newData.length;
              localStorage.setItem('overTimeNum', v.overTimeNum);
              if (type === 'all') {
                v.$refs['overtimeOrderProcess'].initOvertimeOrderProcessingData('timeout', newData, 1);
              }
              resolve(newData);
            } else {
              resolve([]);
            }
          }
        });
      });
    },
    /**
     * 启动超时未发轮询任务。
     * @param {string} value 轮询模式标识。
     */
    handleTimedTasks(value) {
      let v = this;
      if (['/login', '/logout'].includes(v.$route.path)) {
        clearInterval(this.timedTasksTimer);
      } else {
        clearInterval(v.timedTasksTimer);
        v.timedTasksTimer = setInterval(() => {
          if (v.isPageVisible) {
            v.handleTimedSentData(value);
          }
        }, 10 * 60 * 1000);
      }
    },
    // 跳转 帮助中心
    toHelpPage() {
      const {href} = this.$router.resolve({
        path: '/commonHelpCenter'
      });
      window.open(href, '_blank');
    }
  },
  components: {
    viewAnnouncementModal,
    functionSettings,
    overtimeOrderProcessingModal
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('resize', this.setScrollbarWidth);
    this._isDestroyed = true;
    clearInterval(this.localTimeTimer);
    clearInterval(this.utcTimeTimer);
    clearInterval(this.timedTasksTimer);
    clearTimeout(this.scrollbarTimer);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
  watch: {
    // 监听路由变化
    '$route'() {
      this.$nextTick(() => {
        this.setScrollbarWidth();
      });
    }
  },
};
</script>

<style lang="less" scoped>
.header_container {
  position: fixed;
  top: 0;
  left: 0;
  right: var(--scrollbar-width);
  z-index: 1001;
  min-height: 50px;
  height: auto;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  min-width: 90%;

  .right_box .user_info_box {
    display: flex;
    align-items: center;

    .message_reminder_box {
      margin-right: 25px;
      position: relative;
      top: 5px;
      cursor: pointer;
      line-height: 50px;

      .ivu-icon-ios-notifications-outline {
        font-weight: bold;
      }

      .message_reminder_list {
        width: 100%;

        .message_reminder_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #e8eaec;
          padding: 12px;
          cursor: pointer;

          .message_icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-color: #FE5D58;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .message_line {
            width: 250px;

            .title {
              width: 250px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-wrap: break-word;
              word-break: break-all;
              color: #000;
              font-weight: bold;
              font-size: 13px;
            }

            .time {
              margin-top: 4px;
              font-size: 12px;
              color: #BCBCBC;
            }
          }

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: #f0faff;
          }
        }

        .more_style {
          color: #333;
          display: flex;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }

  .left_box {
    /deep/ .reset_menu_styles {
      background: initial;
      height: 50px;
      line-height: 50px;

      &:after {
        height: 0;
      }

      .ivu-menu-item {
        color: #fff;
        padding: 0;
        border-bottom: none;

        &:hover {
          border-bottom: none;
        }

        .title {
          margin: 0 30px;
          display: inline-block;
          position: relative;
        }
      }

      .ivu-menu-item-active {
        background-color: #fff;
        color: #113F6D;
        border-bottom: none;

        &:after {
          content: ' ';
          height: 2px;
          background-color: #113F6D;
          width: 76%;
          display: inline-block;
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .ymsLogo {
      display: inline-block;
      min-width: 140px;
      max-width: 210px;
      height: 22px;
    }

    .trsLogo {
      display: inline-block;
      width: 130px;
      height: 19px;
      position: relative;
      top: 2px;
    }
  }

  .timeout_box {
    height: 32px;
    line-height: 32px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    font-size: 14px;
    color: #D9001B;
    padding: 0px 30px 0 10px;
    display: flex;
    align-items: center;
  }
}
</style>
